'use client';

import React, { useEffect, useState } from 'react';

import classes from './terms-modal.module.scss';
import { useDictionary } from '@/lib/context/locale-provider';
import { termsData } from '@/lib/data/terms';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@/lib/store';
import { setTermsContentKeys, setTermsTitleKeys } from '@/slice/terms';
import { Languages } from '@/lib/dictionaries';

function TermsModal({ lang }: { lang: Languages }) {
  const dict = useDictionary();
  const dispatch = useDispatch();
  const titleKeys = useSelector((state: RootState) => state.terms.titleKeys);
  const contentKeys = useSelector(
    (state: RootState) => state.terms.contentKeys,
  );

  const [title, setTitle] = useState<string>('');
  const [content, setContent] = useState<string>('');

  function handleTermsClose() {
    setTitle('');
    setContent('');
    dispatch(setTermsTitleKeys(''));
    dispatch(setTermsContentKeys(''));
  }

  useEffect(() => {
    if (titleKeys !== '' && contentKeys !== '') {
      const title: any = titleKeys
        .split('.')
        .reduce(
          (obj: { [key: string]: string | any }, key: string) =>
            obj && obj[key] !== undefined ? obj[key] : undefined,
          dict!,
        );
      setTitle(title);

      let content;
      if (contentKeys !== 'specialLaw') {
        content =
          termsData[contentKeys][
            lang === 'ko' ? 'ko' : lang === 'ja' ? 'ja' : 'en'
          ];
      } else {
        content = termsData[contentKeys]['ja'];
      }
      setContent(content);
    }
  }, [titleKeys, contentKeys]);

  return (
    <article
      className={`${classes.termsLayer}`}
      style={{ display: title !== '' ? 'block' : 'none' }}
    >
      <div className={classes.layerWrapper}>
        <div className={classes.layerContents}>
          <button
            className={classes.layerCloseBtn}
            onClick={handleTermsClose}
          ></button>
          <div className={classes.termsGroupBox}>
            <div className={classes.termsHeadBox}>
              <div className={classes.headBox}>{title}</div>
            </div>
            <div className={classes.termsBodyBox}>
              <div className={classes.termsViewBox}>
                <div className={classes.termsMsg}>
                  <div dangerouslySetInnerHTML={{ __html: content }} />
                </div>
              </div>
            </div>
            <div className={classes.termsFootBox}>
              <div className={classes.footBtnList}>
                <button
                  className={`${classes.footBtn} ${classes.themeCancel}`}
                  onClick={handleTermsClose}
                >
                  {dict!.common.confirm}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>
  );
}

export default TermsModal;
